export type IWinSize = ReturnType<typeof calcWinsize>

export const calcWinsize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
})
